// return leadBrand specific contact
export const getContact = (leadBrand) => {
  if (leadBrand === 'medicareassociation') {
    return { text: '(888) 338-9505', href: 'tel:+18883389505' };
  }

  return { text: '(888) 335-8996', href: 'tel:+18883358996' };
};
